export default __webpack_public_path__ + "static/media/aircon_room_use2.1ae2435f.png";